import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { SystemNotesTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
    position?: number;
};

export const schemaLoanRequestResolver_GetSystemNotes = SystemNotesTableDefinitionZod.nullable();

export type SchemaLoanRequestResolver_GetSystemNotes = z.infer<typeof schemaLoanRequestResolver_GetSystemNotes>;

export type LoanRequestResolver_GetSystemNotes = Resolver<Arguments, SchemaLoanRequestResolver_GetSystemNotes>;
